import { v4 as uuidV4 } from 'uuid'
export class Diocese {
  constructor() {
    this.diocese_id = uuidV4()
    this.descricao = ''
  }
}
